import React from 'react'

/** Request URL (full path or absolute) when rendering on server. Used by Helmet for canonical/og:url. */
export const SSRContext = React.createContext({ requestUrl: '' })

export function useSSRUrl() {
  return React.useContext(SSRContext)?.requestUrl || ''
}
